// ============================================
// PROTECTED ROUTE COMPONENT
// ============================================

import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store';
import { ROUTES } from '../../constants';
import { Loader2 } from 'lucide-react';
import styles from './ProtectedRoute.module.css';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <Loader2 className={styles.spinner} size={32} />
        <span>Loading...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Save the attempted URL for redirecting after login
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
